const BASE_URL = "https://sukuto.com/images";
export  const BASE_URL_CITY =  'https://sukuto.com';


const IMAGES = {
  heroImageDesktop: `https://ik.imagekit.io/sukuto/Sukuto/Frontend/Home/heroImageDesktop.webp`,
  heroImageMobile: `https://ik.imagekit.io/sukuto/Sukuto/Frontend/Home/heroImageDesktop.webp?tr=w-900,q-80`,

  lowPrice: `${BASE_URL}/lowPrice.webp`,
  wideFleet: `${BASE_URL}/wideFleet.webp`, 
  verifiedPartners: `${BASE_URL}/verifiedPartners.webp`,
  depositSafe: `${BASE_URL}/depositSafe.webp`,
  customerSupport: `${BASE_URL}/customerSupport.webp`,
  maintainedVehicle: `${BASE_URL}/maintainedVehicle.webp`,

   select_bike: `${BASE_URL}/select_bike.webp`,
   pay_month: `${BASE_URL}/pay_month.webp`,
   home_deliver: `${BASE_URL}/home_deliver.webp`,
   pay_nextmonth: `${BASE_URL}/pay_nextmonth.webp`,
   get_serviced: `${BASE_URL}/get_serviced.webp`,
 

  costEffective: `${BASE_URL}/costEffective.webp`,
  convenience: `${BASE_URL}/convenience.webp`, 
  zeroMaintenance: `${BASE_URL}/zeroMaintenance.webp`,
  flexibility: `${BASE_URL}/flexibility.webp`,
  noCommitment: `${BASE_URL}/noCommitment.webp`,
  noDepreciation: `${BASE_URL}/noDepreciation.webp`,


  whatsapp_icon: `${BASE_URL}/icons/whatsapp_icon.svg`,
  call_icon: `${BASE_URL}/icons/call_logo.svg`,
  
  logo_icon: `${BASE_URL}/icons/Logo.svg`,
  global_icon: `${BASE_URL}/icons/global.svg`,
  elementImg1: `${BASE_URL}/element_1.webp`,
  elementImg2: `${BASE_URL}/element_2.webp`,
  elementImg3: `${BASE_URL}/element_3.webp`,
  elementImg4: `${BASE_URL}/element_4.webp`,
  elementImg5: `${BASE_URL}/element_5.webp`,
  elementImg6: `${BASE_URL}/element_6.webp`,
  elementImg7: `${BASE_URL}/element_7.svg`,
  scrolldown_icon: `${BASE_URL}/scroll_down.gif`,
  GuideSearch: `${BASE_URL}/search/search.svg`,
  ArrowRight: `${BASE_URL}/arrow_right.svg`,
  CurvedArrowBottom: `${BASE_URL}/arrow_from_bottom.svg`,
  CurvedArrowTop: `${BASE_URL}/arrow_from_top.svg`,
  GuideBook: `${BASE_URL}/guide_book.webp`,
  GuideCompare: `${BASE_URL}/guide_compare1.webp`,
  GuideRide: `${BASE_URL}/guide_ride.webp`,
  GuideSearch2: `${BASE_URL}/guide_search.webp`,
  GuideSignup: `${BASE_URL}/guide_signup.svg`,
  shield_anim_git: `${BASE_URL}/shield_animation.gif`,
  city_build_git: `${BASE_URL}/city_building_office.gif`,
  star_gif: `${BASE_URL}/star.gif`,
  StarIcon: `${BASE_URL}/search/star.png`,
  InfoSvg: `${BASE_URL}/search/info.svg`,
  FuelIcon: `${BASE_URL}/search/vehicleCard/fuel.svg`,
  HandIcon: `${BASE_URL}/search/vehicleCard/hand.svg`,
  PaperIcon: `${BASE_URL}/search/vehicleCard/paper.svg`,
  EcoIcon: `${BASE_URL}/search/vehicleCard/eco.svg`,
  CartIcon: `${BASE_URL}/search/cart.svg`,
  CoinGif: `${BASE_URL}/coin.gif`,
  Testimonial_1: `${BASE_URL}/Testimonial_1.webp`,
  Testimonial_2: `${BASE_URL}/Testimonial_2.webp`,
  Testimonial_3: `${BASE_URL}/Testimonial_3.webp`,
  security_illustration: `${BASE_URL}/security_illustration.svg`,
  profile_icon: `${BASE_URL}/profile-icon.svg`,


  MoneyIcon: `${BASE_URL}/checkout/money.png`,
  MountainIcon: `${BASE_URL}/checkout/mountain.png`,
  SpeedIcon: `${BASE_URL}/checkout/speed.png`,
  DeleteIcon: `${BASE_URL}/checkout/delete.svg`,
  HelmetIcon: `${BASE_URL}/checkout/helmet.png`,

  sukutoApp_img: `${BASE_URL}/sukuto_app.svg`,
  googlePlay_img: `${BASE_URL}/icons/google_play_icon.webp`,
  qrCode_img: `${BASE_URL}/qr_code.svg`,
  applePlay_img: `${BASE_URL}/icons/app_store_icon.webp`,

  phone:`${BASE_URL}/phone.png`,
  mail:`${BASE_URL}/mail.png`,
  location:`${BASE_URL}/location.png`,

  location_svg: `${BASE_URL}/icons/location_pin.svg`,
  email_svg: `${BASE_URL}/icons/email.svg`,
  phone_svg: `${BASE_URL}/icons/phone.svg`,

  pay_upi: `${BASE_URL}/icons/pay_upi.svg`,
  pay_amex: `${BASE_URL}/icons/pay_amex.svg`,
  pay_apple_pay: `${BASE_URL}/icons/pay_apple_pay.svg`,
  pay_lazypay: `${BASE_URL}/icons/pay_lazypay.svg`,
  pay_mastercard: `${BASE_URL}/icons/pay_mastercard.svg`,
  pay_paypal: `${BASE_URL}/icons/pay_paypal.svg`,
  pay_rupay: `${BASE_URL}/icons/pay_rupay.svg`,
  pay_visa: `${BASE_URL}/icons/pay_visa.svg`,
  pay_simpl: `${BASE_URL}/icons/pay_simpl.svg`,
  bike_icon: `${BASE_URL}/icons/bike-icon.svg`,
  car_icon: `${BASE_URL}/icons/car-icon.svg`,

  explorer1: `${BASE_URL}/explorer_1.png`,
  explorer2: `${BASE_URL}/explorer_2.png`,
  explorer3: `${BASE_URL}/explorer_3.png`,
  FindIllustration: `${BASE_URL}/find-icon.svg`,

  question_icon: `${BASE_URL}/icons/question.svg`,

  candy_icon: `${BASE_URL}/icons/candy.svg`,
  building_icon: `${BASE_URL}/icons/building.svg`,

  thinking_icon: `${BASE_URL}/icons/thinking.svg`,

  whatsapp: `${BASE_URL}/WhatsApp 1.png`,
  arrowillustration: `${BASE_URL}/arrow_illustration.png`,
  onlinebooking: `${BASE_URL}/Online Booking 1.png`,
  bluestars: `${BASE_URL}/Group 1261153982.png`,

  insta: `${BASE_URL}/instagram.png`,
  frame1: `${BASE_URL}/Frame 1261155660.png`,
  frame2: `${BASE_URL}/Frame 1261155656.png`,
  frame3: `${BASE_URL}/Frame 1261155647.png`,
  frame4: `${BASE_URL}/Frame 1261155655.png`,
  frame5: `${BASE_URL}/coupon.png`,
  frame6: `${BASE_URL}/Frame 1261155658.png`,
  frame7: `${BASE_URL}/Frame 1261155659.png`,
  frame8: `${BASE_URL}/Frame 1261155661.png`,
  contactimg: `${BASE_URL}/halfcircle.png`,

 

  rupeeicon: `${BASE_URL}/rupees icon.png`,
  greendot: `${BASE_URL}/green dot.png`,
  reddot: `${BASE_URL}/red dot.png`,
  splender: `${BASE_URL}/Splendor_Plus.png`,
  scooty: `${BASE_URL}/scooty.png`,

  email_icon: `${BASE_URL}/email.png`,
  google_icon: `${BASE_URL}/google.png`,
  facebook_icon: `${BASE_URL}/facebook.png`,
  apple_icon: `${BASE_URL}/apple.png`,
  phonered_svg: `${BASE_URL}/phone-red.svg`,

  redarrow_icon: `${BASE_URL}/icons/red-arrow.svg`,
  zerodeposit_icon: `${BASE_URL}/icons/zero-deposit.svg`,

  moneyhand: `${BASE_URL}/moneyhand.png`,
  bwscooty: `${BASE_URL}/bwscooty.png`,
  flymoney: `${BASE_URL}/flymoney.png`,
  lockkey: `${BASE_URL}/lock&key.png`,
  thumbprint: `${BASE_URL}/thumbprint.png`,
  avatar: `${BASE_URL}/avata.png`,
  license: `${BASE_URL}/drivngLicense.png`,
  vfn: `${BASE_URL}/vfn.png`,
  invite: `${BASE_URL}/invite.png`,
  colorbg: `${BASE_URL}/colorbg.png`,
  copy: `${BASE_URL}/copy.png`,
  dot: `${BASE_URL}/Bangalore.png`,
  path_icon1: `${BASE_URL}/icons/path-icon1.svg`,
  path_icon2: `${BASE_URL}/icons/path-icon2.svg`,
  tab_img1: `${BASE_URL}/tab-1.png`,
  tab_img2: `${BASE_URL}/tab-2.png`,
  facecool_icon: `${BASE_URL}/icons/face-cool.svg`,
  underline_img: `${BASE_URL}/underline-red.svg`,
  tabcard_img1: `${BASE_URL}/tabcard-1.png`,
  tabcard_img2: `${BASE_URL}/tabcard-2.png`,
  tabcard_img3: `${BASE_URL}/tabcard-3.png`,

  activeScooter: `${BASE_URL}/icons/active-scooter.svg`,
  inactiveScooter: `${BASE_URL}/icons/inactive-scooter.svg`,
  activeMoterBike: `${BASE_URL}/icons/active-moterbike.svg`,
  inactiveMoterBike: `${BASE_URL}/icons/inactive-moterbike.svg`,
  activeCar: `${BASE_URL}/icons/active-car.svg`,
  inactiveCar: `${BASE_URL}/icons/inactive-car.svg`,
  activeElectScooter: `${BASE_URL}/icons/active-electbike.svg`,
  inactiveElectScooter: `${BASE_URL}/icons/inactive-electbike.svg`,
  activeElectBike: `${BASE_URL}/icons/active-electbike.svg`,
  inactiveElectBike: `${BASE_URL}/icons/inactive-electbike.svg`,
  activeAccessories: `${BASE_URL}/icons/active-accessories.svg`,
  inactiveAccessories: `${BASE_URL}/icons/inactive-accessories.svg`,
  search_icon: `${BASE_URL}/icons/search-icon.svg`,
  headthumb_icon: `${BASE_URL}/head-thumb.svg`,
  close:`${BASE_URL}/close.svg`,
  hondaBike: `${BASE_URL}/honda-bike.png`,

  menu_icon: `${BASE_URL}/icons/menu-icon.svg`,
  cart_icon: `${BASE_URL}/icons/cart-icon.svg`,
  searchmb_icon: `${BASE_URL}/icons/searchmb-icon.svg`,
  booking_icon: `${BASE_URL}/icons/booking-icon.svg`,
  accountmb_icon: `${BASE_URL}/icons/accountmb-icon.svg`,
  emptyCart: `${BASE_URL}/empty-cart.svg`,
  filter_icon: `${BASE_URL}/icons/filter-icon.svg`,
  arrowLeft_icon: `${BASE_URL}/icons/arrow-left.svg`,
  Chevron_icon: `${BASE_URL}/icons/chevron-left.svg`,
  whatsapp2_icon: `${BASE_URL}/icons/whatsapp.svg`,
  call2_icon: `${BASE_URL}/icons/call.svg`,

  Success: `${BASE_URL}/success.gif`,
  Failed: `${BASE_URL}/failed.gif`,
  Spinner1: `${BASE_URL}/spinner1.svg`,
  Spinner2: `${BASE_URL}/spinner2.gif`,

  blog_top: `${BASE_URL}/blog_banner.png`,
  blog1: `${BASE_URL}/blog1.png`,
  blog11: `${BASE_URL}/blog1-1.png`,
  heart_icon: `${BASE_URL}/icons/heart.svg`,
  view_icon: `${BASE_URL}/icons/view.svg`,
  share_icon: `${BASE_URL}/icons/share.svg`,
  blog_banner: `${BASE_URL}/blog-banner1.jpg`,
  blogDefaultImg: `${BASE_URL}/img_notfound.png`,

  Ahmedabad: `${BASE_URL}/city_ahmedabad.png`,
  Bangalore: `${BASE_URL}/city_bangalore.png`,
  Bhubaneswar: `${BASE_URL}/city_bhubneshwer.png`,
  Chandigarh: `${BASE_URL}/city_chandigarh.png`,
  Chennai:  `${BASE_URL}/city_chennai.png`,
  Coimbatore: `${BASE_URL}/city_coimbatore.png`,
  Dandeli:`${BASE_URL}/city_dandeli.png`,
  Dehradun: `${BASE_URL}/city_dehradun.png`,
  Delhi: `${BASE_URL}/city_delhi.png`,
  Goa: `${BASE_URL}/city_goa.png`,
  Gokarna: `${BASE_URL}/city_gokarna.png`,
  Udaipur: `${BASE_URL}/city_gokarna.png`,
  Gurugram: `${BASE_URL}/city_gurugram.png`,
  Guwahati: `${BASE_URL}/city_guwahati.png`,
  Hampi: `${BASE_URL}/city_hampi.png`,
  Chikmagalur: `${BASE_URL}/city_hikmagalur.png`,
  Hyderabad: `${BASE_URL}/city_hyderabad.png`,
  Indore: `${BASE_URL}/city_indore.png`,
  Jaipur: `${BASE_URL}/city_jaipur.png`,
  Kochi: `${BASE_URL}/city_kochi.png`,
  Kolkata: `${BASE_URL}/city_kolkata.png`,
  Leh: `${BASE_URL}/city_leh.png`,
  LehLadakh: `${BASE_URL}/city_leh_ladakh.png`,
  Manali: `${BASE_URL}/city_manali.png`,
  Mangalore: `${BASE_URL}/city_mangalore.png`,
  Mumbai: `${BASE_URL}/city_mumbai.png`,
  Nainital: `${BASE_URL}/city_nainital.png`,
  Pondicherry: `${BASE_URL}/city_pondicherry.png`,
  Pune: `${BASE_URL}/city_pune.png`,
  Pushkar: `${BASE_URL}/city_pushkar.png`,
  Raipur: `${BASE_URL}/city_raipur.png`,
  Rishikesh: `${BASE_URL}/city_rishikesh.png`,
  Siliguri: `${BASE_URL}/city_siliguri.png`,
  Thiruvananthapuram: `${BASE_URL}/city_thiruvananthapuram.png`,
  Bhopal: `${BASE_URL}/city_udaipur.png`,
  Vizag: `${BASE_URL}/city_vizag.png`,


  HeartIllustration: `${BASE_URL}/heart-illustration.svg`,

  SummerEs: `${BASE_URL}/summer-es.svg`,

  arrowDown: `${BASE_URL}/icons/arrow_down.svg`,
  arrowUp: `${BASE_URL}/icons/arrow_up.svg`,

};

export default IMAGES;